import { createSlice } from "@reduxjs/toolkit";
import { storage } from "../../helpers/storage";

const initialState = {
  value: {
    id: null,
    name: null,
    image: null,
    phone: null,
    email: null,
    address: null,
    currency: null,
    currencyCode: null,
    countryCode: null,
    description: null,
    categories: [],
    deliveries: [],
    uId: null,
    tax_rate: {
      rate: 0,
      status: false,
      allow_exemp: false,
      type: "add_to_price",
      category: "percentage",
      description: "",
    },
    subscription: {},
    loading: true,
  },
};

const organization = createSlice({
  name: "organization",
  initialState,
  reducers: {
    updateOrganization: (state, data) => {
      return {
        value: {
          ...state.value,
          id: data.payload.id,
          uId: data.payload.uId,
          name: data.payload.name,
          email: data.payload.email,
          image: data.payload.image,
          phone: data.payload.phone,
          address: data.payload.address,
          currency: data.payload.currency,
          currencyCode: data.payload.currencyCode,
          countryCode: data.payload.country_code,
          description: data.payload.description,
        },
      };
    },
    updateCurrency: (state, data) => {
      return {
        value: {
          ...state.value,
          currency: data.payload.currency,
          currencyCode: data.payload.currencyCode,
        },
      };
    },
    updateCategories: (state, data) => {
      return {
        value: {
          ...state.value,
          categories: data.payload.categories,
        },
      };
    },
    replaceCategory: (state, data) => {
      state.value.categories = state.value.categories.map((el) =>
        el?.id && el?.id === data.payload.category?.id
          ? data.payload.category
          : el
      );
      storage.set("categories", JSON.stringify(state.value.categories));
    },
    addNewCategory: (state, data) => {
      state.value.categories = [
        ...state.value.categories,
        data.payload.category,
      ];
      storage.set("categories", JSON.stringify(state.value.categories));
    },
    removeCategory: (state, data) => {
      state.value.categories = state.value.categories.filter(
        (el) => el?.id !== data.payload.category?.id
      );
      storage.set("categories", JSON.stringify(state.value.categories));
    },
    updateTaxRate: (state, data) => {
      state.value.tax_rate = data.payload.tax_rate;
      storage.set("taxRate", data.payload.tax_rate);
    },
    updateDeliveries: (state, data) => {
      state.value.deliveries = data.payload.deliveries;
    },
    addNewDelivery: (state, data) => {
      state.value.deliveries = [
        ...state.value.deliveries,
        data.payload.delivery,
      ];
      storage.set("deliveries", JSON.stringify(state.value.deliveries));
    },
    updateExistingDelivery: (state, data) => {
      state.value.deliveries = state.value.deliveries.map((el) =>
        el?.id && el?.id === data.payload.delivery?.id
          ? data.payload.delivery
          : el
      );
      storage.set("deliveries", JSON.stringify(state.value.deliveries));
    },
    removeDelivery: (state, data) => {
      state.value.deliveries = state.value.deliveries.filter(
        (el) => el?.id !== data.payload.delivery?.id
      );
      storage.set("deliveries", JSON.stringify(state.value.deliveries));
    },
    clearOrganization: () => {
      return {
        ...initialState,
      };
    },
    updateOrganizationSubscription: (state, data) => {
      state.value.subscription = data.payload.subscription;
    },
    updateLoadingOrg: (state, data) => {
      state.value.loading = data.payload;
    },
  },
});

export const {
  updateOrganization,
  updateCurrency,
  updateCategories,
  replaceCategory,
  addNewCategory,
  removeCategory,
  updateTaxRate,
  clearOrganization,
  updateOrganizationSubscription,
  updateLoadingOrg,
  addNewDelivery,
  updateDeliveries,
  updateExistingDelivery,
  removeDelivery,
} = organization.actions;

export default organization.reducer;
